module.exports = "/_next/static/images/ee36155d75673b83bd9caa82dda130e0-slide-2-small.png.webp";